import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

// Import Style
import './Subscribe.scss';

class Subscribe extends Component {
  static defaultProps = {
    user: {},
  };

  constructor() {
    super();
  }

  render() {
    const { user, dashboardsCount } = this.props;
    const remainingTrial = moment(user.trialEnd).diff(moment(), 'days') + 1;
    const dashboardsLine = dashboardsCount ? `\nNumber of dashboards: ${dashboardsCount}` : '';
    const quoteBody = `Hi Nave team,\nI'd like a pricing quote for a Nave plan.\n\nAccount: ${user.email}${dashboardsLine}\nTrial end date: ${moment(user.trialEnd).format('D MMM YYYY')}`;
    const quoteHref = `mailto:hello@getnave.com?subject=${encodeURIComponent('Nave plan pricing request')}&body=${encodeURIComponent(quoteBody)}`;

    let status;
    let tone = '';
    if (user.trialExpired) {
      status = 'Trial ended';
      tone = 'ended';
    } else if (user.cancelled) {
      status = 'Subscription ended';
      tone = 'ended';
    } else {
      status = `Trial · ${remainingTrial} ${remainingTrial === 1 ? 'day' : 'days'} left`;
      tone = remainingTrial <= 1 ? 'ended' : remainingTrial <= 3 ? 'soon' : '';
    }

    return (
      <div className={`subscribe_box trial_status ${tone}`}>
        <span>{status}</span>
        {user.status == 'trial' && (
          <a href={quoteHref} className='trial_status_action'>Request a quote →</a>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    dashboardsCount: state.auth.user.dashboards,
  };
};

export default connect(mapStateToProps)(Subscribe);
